import React from "react";
import classNames from "classnames";
import { BemHelper } from "@/utils/BemHelper";
import { currencyFormat, useBreakpointValue } from "@/utils/index";
import { truncateHtmlToPlainText } from "@/utils/stringHelpers";
import defaultImage from "./images/default-product.jpeg";

export type ProductPublicCardProps = {
  name: string;
  price: number | string;
  description: string;
  image?: string;
  actions?: React.ReactNode;
  topActions?: React.ReactNode;
  hidePrice?: boolean;
  onClick?: () => void;
  onImageClick?: () => void;
  highlight?: boolean;
  style?: React.CSSProperties;
};

const bem = new BemHelper("product-public-card");

export const ProductPublicCard: React.FC<ProductPublicCardProps> = ({
  name,
  price,
  description,
  image,
  actions,
  topActions,
  hidePrice,
  onClick,
  highlight,
  onImageClick,
  style = {},
}) => {
  const isMobile = useBreakpointValue({ base: false, xs: true });

  return (
    <div
      className={classNames(
        bem.block(),
        highlight && bem.modifier("highlighted"),
        isMobile && bem.modifier("mobile"),
      )}
      style={style}
    >
      <div
        className={classNames(
          bem.element("image"),
          isMobile && bem.element("image-mobile"),
          onImageClick && bem.modifier("has-actions"),
        )}
        onClick={() => onImageClick && onImageClick()}
      >
        <img src={image || defaultImage} />
      </div>

      <div
        className={classNames(
          bem.element("content"),
          isMobile && bem.modifier("mobile", "content"),
        )}
      >
        <div>
          <div className={classNames(bem.element("header"))}>
            <h2
              onClick={() => onClick && onClick()}
              className={classNames(
                // "cr-ct-h3",
                bem.element("title"),
                isMobile && bem.modifier("mobile", "title"),
                onClick && bem.modifier("has-actions"),
              )}
            >
              {truncateHtmlToPlainText(name, 50)}
            </h2>
            {topActions && (
              <div className={classNames(bem.element("top-actions"))}>{topActions}</div>
            )}
          </div>

          {!hidePrice && (
            <div
              className={classNames(
                bem.element("price"),
                isMobile && bem.modifier("mobile", "price"),
              )}
            >
              {parseFloat(price.toString()) !== 0 ? currencyFormat(price) : "FREE"}
            </div>
          )}

          {!isMobile && (
            <div
              className={classNames("text-color-third", bem.element("description"))}
              dangerouslySetInnerHTML={{ __html: truncateHtmlToPlainText(description, 120) }}
            />
          )}
        </div>

        {actions && <div className={classNames(bem.element("footer"))}>{actions}</div>}
      </div>
    </div>
  );
};
